import { mathCalculators } from "../Ar/MathCalculator/ConstantsMathCalculator";
import { womenCalculators } from "../Ar/WomenCalculator/ConstantsWomenCalculator";
import { financialCalculators } from "../Ar/FinancialCalculator/ConstantsFinancialCalculator";
import { humanCalculators } from "../Ar/HumanCalculator/ConstantsHumanCalculator";
import { islamicCalculators } from "../Ar/IslamicCalculator/ConstantsIslamicCalculator";
import { studyCalculators } from "../Ar/StudyCalculator/ConstantsStudyCalculator";
import { physicsCalculators } from "../Ar/PhysicsCalculator/ConstantsPhysicsCalculator";
import { healthCalculators } from "../Ar/HealthCalculator/ConstantsHealthCalculator";
import { otherCalculators } from "../Ar/OtherCalculator/ConstantsOtherCalculator";
import { chemistryCalculators } from "../Ar/ChemistryCalculator/ConstantsChemistryCalculator";
import { unitConverters } from "./UnitConverter/ConstantsUnitConverter";
import { foodCalculators } from "./FoodCalculator/ConstantsFoodCalculator";
import SharedHelmet from "./Helmet";
import { useState } from "react";
import { Icons } from "../../Components/Icons";

const TITLE = "جميع الحاسبات";
const DESCRIPTION = "يمكنك هنا ايجاد جميع الحاسبات في موقع احسب";
const KEYWORDS = "جميع الحاسبات";
const OG_URL = "https://do-calculate.com/ar/all-calculators/";

const cardData = [
  {
    cardNumber: 12,
    cardTitle: "حواسب الطعام",
    cardIcon: <Icons.Food />,
    cardItems: foodCalculators,
    calculatorUrl: "/ar/food-calculators/",
  },

  {
    cardNumber: 3,
    cardTitle: "حواسب المرأة",
    cardIcon: <Icons.Female />,
    cardItems: womenCalculators,
    calculatorUrl: "/ar/women-calculators/",
  },
  {
    cardNumber: 5,
    cardTitle: "حواسب الزكاة",
    cardIcon: <Icons.VolunteerActivism />,
    cardItems: islamicCalculators,
    calculatorUrl: "/ar/zakat-calculators/",
  },
  {
    cardNumber: 11,
    cardTitle: " حواسب التحويل",
    cardIcon: <Icons.Transform />,
    cardItems: unitConverters,
    calculatorUrl: "/ar/unit_converter/",
  },
  {
    cardNumber: 9,
    cardTitle: "الحواسب المالية",
    cardIcon: <Icons.AttachMoney />,
    cardItems: financialCalculators,
    calculatorUrl: "/ar/financial-calculators/",
  },
  {
    cardNumber: 1,
    cardTitle: "حواسب الزمن والتاريخ",
    cardIcon: <Icons.AccessTime />,
    cardItems: humanCalculators,
    calculatorUrl: "/ar/date-time-calculators/",
  },
  {
    cardNumber: 10,
    cardTitle: " حواسب اخرى",
    cardIcon: <Icons.MoreHoriz />,
    cardItems: otherCalculators,
    calculatorUrl: "/ar/other-calculators/",
  },
  {
    cardNumber: 6,
    cardTitle: "حواسب المعدلات الجامعية",
    cardIcon: <Icons.School />,
    cardItems: studyCalculators,
    calculatorUrl: "/ar/study-calculators/",
  },
  {
    cardNumber: 7,
    cardTitle: "حواسب الفيزياء",
    cardIcon: <Icons.Science />,
    cardItems: physicsCalculators,
    calculatorUrl: "/ar/physics-calculators/",
  },
  {
    cardNumber: 2,
    cardTitle: "حواسب الصحة واللياقة",
    cardIcon: <Icons.Favorite />,
    cardItems: healthCalculators,
    calculatorUrl: "/ar/health-calculators/",
  },
  {
    cardNumber: 4,
    cardTitle: "حواسب الرياضيات",
    cardIcon: <Icons.Calculate />,
    cardItems: mathCalculators,
    calculatorUrl: "/ar/math-calculators/",
  },
  {
    cardNumber: 8,
    cardTitle: "حواسب الكيمياء",
    cardIcon: <Icons.Biotech />,
    cardItems: chemistryCalculators,
    calculatorUrl: "/ar/chemistry-calculators/",
  },
];

function CardGroups() {
  const [searchTerm, setSearchTerm] = useState("");
  const filteredCardData = cardData.filter((card) =>
    card.cardItems.some((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <div style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div
        className="row row-cols-1 row-cols-md-4 g-4"
        style={{ position: "relative", zIndex: "1" }}
      >
        {filteredCardData.map((card, index) => (
          <div className="col" xs key={index} style={{ paddingBottom: "10px" }}>
            <div>
              <h2 style={{ fontSize: "16px" }}>
                {card.cardIcon} {card.cardTitle}
              </h2>
              <ul style={{ padding: 0, listStyleType: "none" }}>
                {card.cardItems.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    <a
                      href={item.link}
                      className="item-link"
                      style={{ fontSize: "14px" }}
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
      <hr />
      <div className="p-3 mb-2 bg-success text-white">
        في حال لديك أي استعلام أو ترغب من فريقنا بإضافة حواسب أخرى أو حتى تريد
        أن تبلغ عن مشكلة في حاسبة معينة, يرجى إخبارنا على البريد الالكتروني
        التالي : info@do-calculate.com
      </div>
    </div>
  );
}

export default CardGroups;